import request from '@/utils/request'
import qs from 'qs'
//搜索
export function bookList (params) {
  return request({
    url: '/public/book/list?' + qs.stringify(params),
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

export function bookListUser (params) {
  return request({
    url: '/business/book/list?' + qs.stringify(params),
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js